<template>
    <div class="all_ynjc">
        <div class="main_ynjc">
            <!--头部-->
            <header1></header1>
            <!--导航-->
            <navigation></navigation>
            <div class="position_ynjc">您所在的位置：<router-link  :to="{ path: '/'}">首&nbsp;页</router-link><span>&gt;&gt;</span>政策法规</div>
            <!--政策法规/下载专区-->
            <newsList :settings="lastNewsSettings"></newsList>
            <!--版权-->
            <footer1></footer1>
        </div>
    </div>
</template>

<script>
    import  header1 from '../components/Header1';
    import  navigation from '../components/Navigation';
    import  footer1 from '../components/Footer1';
    import  newsList from '../components/NewsList';

    export default {
        name: 'index',
        components: {
            header1,
            footer1,
            navigation,
            newsList
        },
        data () {
            return {
                lastNewsSettings: {
                    consultName:'政策法规',
                    consultId: 55,
                    publishState: 0,
                    publishTime: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
                    'displayPositionIds': [1, 3],
                    'notProjectIds': [8, 9],
                    'orderWeight': true,
                    orderPublishTime: true,
                    pageNum: 1,
                    pageSize: 10
                },
            }
        },

        mounted () {

        },
        methods: {

        }
    }
</script>